"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTOMATION_BATCH_ROW_LIMIT = void 0;
exports.normalizeAutomationBatchSize = normalizeAutomationBatchSize;
exports.automationRowsPerRun = automationRowsPerRun;
/** The most rows one run of an automation takes in batch mode. */
exports.AUTOMATION_BATCH_ROW_LIMIT = 100;
/** A batch size as a whole number of rows from 1 to the batch row limit. */
function normalizeAutomationBatchSize(requested) {
    if (!Number.isFinite(requested)) {
        throw new Error('Automation batch size must be a finite number.');
    }
    const normalized = Math.max(1, Math.floor(requested));
    if (normalized > exports.AUTOMATION_BATCH_ROW_LIMIT) {
        throw new Error(`Automation batch size ${normalized} exceeds the current limit of ${exports.AUTOMATION_BATCH_ROW_LIMIT} rows. Reduce the batch size or narrow the input filter.`);
    }
    return normalized;
}
/** A run takes one row in "next row" mode and its batch size in batch mode. */
function automationRowsPerRun(settings) {
    return settings.executionMode === 'batch'
        ? normalizeAutomationBatchSize(settings.batchSize ?? exports.AUTOMATION_BATCH_ROW_LIMIT)
        : 1;
}
//# sourceMappingURL=batch.js.map